import { useContext } from 'preact/hooks';

import type { TemplateFunction, TemplateResult } from 'Components/types';
import { garageEmptySelector } from 'Core/selectors/fitmentSearch/index';
import { useSelector } from 'Core/store';

import GarageContext from '../garageContext';
import EmptyDropdown, { type EmptyDropdownTemplateParams } from './emptyDropdown';
import ListDropdown, { type ListDropdownTemplateParams } from './listDropdown';
import VehicleDropdowns, { type VehicleDropdownsTemplateParams } from './vehicleDropdowns';

interface Props {
  template: TemplateFunction<BaseDropdownTemplateParams>;
}

export type BaseDropdownTemplateParams =
  | EmptyDropdownTemplateParams
  | ListDropdownTemplateParams
  | VehicleDropdownsTemplateParams;

export default function BaseDropdown(props: Props): TemplateResult {
  const isEmpty = useSelector(garageEmptySelector);
  const { isShowVehicleDropdowns } = useContext(GarageContext);

  const Component = isShowVehicleDropdowns ? VehicleDropdowns : isEmpty ? EmptyDropdown : ListDropdown;

  return <Component {...props} />;
}
